import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

export default class PuntBlockedRecovery extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.KickNotRecovered ||
            fragment.associatedState === FootballState.KickRecovered
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { recoveredAt, recoveredBy } = fragment;

        gameContext.setCurrentPlayerInPossession(recoveredBy);
        gameContext.setPossessionForTeamId(recoveredBy.teamId);
        gameContext.setFieldPosition(recoveredAt);
    }
}
